import type { FC, ReactNode } from 'react'
import type { FaqItem } from '@/types'

import { ChevronDown } from 'lucide-react'

import { cn } from '@/lib/utils'

interface FaqProps {
    items: FaqItem[]
    heading?: string
    className?: string
}

export const Faq: FC<FaqProps> = ({
    items,
    heading = 'Common questions',
    className
}): ReactNode => {
    if (items.length === 0) return null

    return (
        <section aria-labelledby='faq-heading' className={className}>
            <h2 id='faq-heading' className='font-heading text-2xl font-bold tracking-tight'>
                {heading}
            </h2>

            <dl className='mt-6 divide-y divide-border rounded-xl border border-border bg-card'>
                {items.map(item => (
                    <div key={item.question} className='p-0'>
                        <details className='group [&_summary::-webkit-details-marker]:hidden'>
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-4 p-5'>
                                <dt className='text-sm font-semibold leading-snug sm:text-base'>
                                    {item.question}
                                </dt>
                                <ChevronDown
                                    className={cn(
                                        'size-4 shrink-0 text-muted-foreground transition-transform',
                                        'group-open:rotate-180'
                                    )}
                                    aria-hidden='true'
                                />
                            </summary>

                            <dd className='px-5 pb-5 text-sm leading-relaxed text-muted-foreground'>
                                {item.answer}
                            </dd>
                        </details>
                    </div>
                ))}
            </dl>
        </section>
    )
}
